import {
  createRoot,
  type EventHandler,
  type EventNode,
  type TypedEvent,
} from "#js/util/component-hierarchy"
import {
  attachComponentNode,
  findComponentNode,
} from "#js/util/component-hierarchy-dom"

/** Owns one logical node for a custom-element Presenter. */
export class ElementHierarchyController {
  #detach: (() => void) | null = null
  #node: EventNode<TypedEvent> | null = null
  #standaloneRoot: EventNode<TypedEvent> | null = null

  get node(): EventNode<TypedEvent> | null {
    return this.#node
  }

  connect(host: HTMLElement, handler?: EventHandler<TypedEvent>): void {
    this.disconnect()
    const attachedParent = findComponentNode(host)
    const parent = attachedParent ?? createRoot<TypedEvent>()
    if (!attachedParent) this.#standaloneRoot = parent
    const node = parent.createChild()
    if (handler) node.subscribe(handler)
    this.#detach = attachComponentNode(host, node)
    this.#node = node
  }

  dispatch<Event extends TypedEvent>(
    event: Event,
  ): "handled" | "unhandled" | "rejected" {
    return this.#node?.dispatch(event).status ?? "rejected"
  }

  disconnect(): void {
    this.#detach?.()
    this.#detach = null
    this.#node?.dispose()
    this.#node = null
    this.#standaloneRoot?.dispose()
    this.#standaloneRoot = null
  }
}
